module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAA9UlEQVQ4T5XSsS6EQRAA4G+ETlQqBaHRKkWr5AFIlChQalBL6DmEVkGv4AVEIh5AI66VKDQSwsgmfrkcufNvssVmd76dmd3IzAYW0afeeMdRZOYHZnBfL944LgqQWI6I4zpAZq5gvwKeMRsR1/9BMnMKl+ivgF2sYiMi9johmbmGHRxgvQJGMIQz3JSmRsRLK5SZAzhBuX0ej2X+ABHRzMxBnGIUcxFxV5DMnMA5HrAQEU+ZOfwL+D7cgy1sopTziSrt7Ygo64L+DVRpZ+YkSqffcBgRt20ldQa6vUZrBuUjTaPZLahtfwxXpYnlKy+htybwisYXE/B+/E8ilbcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/letter1.png
// module id = AC9r
// module chunks = 1